import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_expense",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mr-b-0em" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mr-b-0em" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mr-b-0em" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mr-b-0em" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mr-b-0em" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-group mr-b-0em" }
const _hoisted_20 = { class: "row mt-2 mb-2" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = {
  key: 0,
  class: "row"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mr-b-0em" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_27 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_28 = { class: "form-group mr-b-0em" }
const _hoisted_29 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_30 = { class: "form-group mr-b-0em" }
const _hoisted_31 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_32 = { class: "form-group mr-b-0em" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mr-b-0em" }
const _hoisted_35 = { class: "col-12 text-right" }
const _hoisted_36 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_price_input = _resolveComponent("price-input")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_inputTextarea = _resolveComponent("inputTextarea")!
  const _component_checkboxInput = _resolveComponent("checkboxInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestExpense)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('views.clients.expense.add')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_add_expense', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestExpense)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestExpense.title,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestExpense.title) = $event)),
                        label: _ctx.i18n.t('tables.expense.title'),
                        v: _ctx.v$.title,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_SingleSelect, {
                        TextLabel: _ctx.i18n.t('tables.expense.category_name'),
                        trackby: `id`,
                        label: `name`,
                        valueProp: `id`,
                        modelValue: _ctx.requestExpense.expense_category_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestExpense.expense_category_id) = $event)),
                        placeholder: `Dossiers`,
                        arrayOptions: _ctx.categoriesList,
                        refs: "subscriptions",
                        v: _ctx.v$.expense_category_id
                      }, null, 8, ["TextLabel", "modelValue", "arrayOptions", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_SingleSelect, {
                        TextLabel: _ctx.i18n.t('tables.expense.service_name'),
                        trackby: `id`,
                        label: `name`,
                        valueProp: `id`,
                        modelValue: _ctx.requestExpense.expense_service_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestExpense.expense_service_id) = $event)),
                        placeholder: `Dossiers`,
                        arrayOptions: _ctx.servicesList?.filter((s) => s?.expense_category_id === _ctx.requestExpense?.expense_category_id),
                        refs: "subscriptions",
                        v: _ctx.v$.expense_service_id
                      }, null, 8, ["TextLabel", "modelValue", "arrayOptions", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_price_input, {
                        modelValue: _ctx.requestExpense.total_amount,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestExpense.total_amount) = $event)),
                        label: _ctx.i18n.t('tables.expense.total_amount'),
                        v: _ctx.v$.total_amount,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_date_field, {
                        modelValue: _ctx.requestExpense.date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestExpense.date) = $event)),
                        label: _ctx.i18n.t('tables.expense.date'),
                        v: _ctx.v$.date,
                        disabled: false,
                        fixedDays: 1,
                        isFixedDays: true
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_inputTextarea, {
                        modelValue: _ctx.requestExpense.description,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestExpense.description) = $event)),
                        label: _ctx.i18n.t('tables.expense.description'),
                        v: _ctx.v$.description,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_checkboxInput, {
                      text: _ctx.i18n.t('views.clients.new_subscriptions.payment.want_to_pay'),
                      modelValue: _ctx.selectedPayment,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedPayment) = $event)),
                      name: "selectedPayment",
                      id: "selectedPayment"
                    }, null, 8, ["text", "modelValue"])
                  ])
                ]),
                (_ctx.selectedPayment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_date_field, {
                            modelValue: _ctx.requestExpense.payment.paymentDate,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestExpense.payment.paymentDate) = $event)),
                            label: _ctx.i18n.t('tables.payment.paymentDate'),
                            v: _ctx.v$.payment.paymentDate,
                            disabled: false,
                            fixedDays: 1,
                            isFixedDays: true
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.payment.paymentMethod'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestExpense.payment.paymentMethod,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestExpense.payment.paymentMethod) = $event)),
                          placeholder: _ctx.i18n.t('tables.payment.paymentMethod'),
                          arrayOptions: _ctx.payment_methodsList,
                          refs: "paymentMethod",
                          v: _ctx.v$.payment.paymentMethod
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      (_ctx.requestExpense.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_SingleSelect, {
                              TextLabel: _ctx.i18n.t('tables.payment.bankName'),
                              trackby: `id`,
                              label: `name`,
                              valueProp: `id`,
                              modelValue: _ctx.requestExpense.payment.bankName,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestExpense.payment.bankName) = $event)),
                              placeholder: _ctx.i18n.t('tables.payment.bankName'),
                              arrayOptions: _ctx.bank_namesList,
                              refs: "bankName",
                              v: _ctx.v$.payment.bankName
                            }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestExpense.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestExpense.payment.chequeName,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestExpense.payment.chequeName) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeName'),
                                v: _ctx.v$.payment.chequeName,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestExpense.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestExpense.payment.chequeNum,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestExpense.payment.chequeNum) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeNum'),
                                v: _ctx.v$.payment.chequeNum,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestExpense.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_date_field, {
                                modelValue: _ctx.requestExpense.payment.dueDate,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestExpense.payment.dueDate) = $event)),
                                label: _ctx.i18n.t('tables.payment.dueDate'),
                                v: _ctx.v$.payment.dueDate,
                                disabled: false,
                                fixedDays: 1,
                                isFixedDays: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_price_input, {
                            modelValue: _ctx.requestExpense.payment.amount_paid,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestExpense.payment.amount_paid) = $event)),
                            label: _ctx.i18n.t('tables.payment.amount_paid'),
                            v: _ctx.v$.payment.amount_paid,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", _hoisted_36, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.emptyState())),
                    class: "btn btn-cancel"
                  }, _toDisplayString(_ctx.i18n.t('button.cancel')), 1)
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}